import { useSelector } from 'react-redux';
import Modal from '../../../../../components/Modal';
import messages from '../../../../../assets/locale/messages';

const DeleteExpenseModal = ({
  openDeleteConfirm,
  handleCloseDeleteConfirmModal,
  handleDeleteExpense,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const { shared, mimarProfit } = messages[lang];

  return (
    <Modal
    open={openDeleteConfirm}
    handleClose={handleCloseDeleteConfirmModal}
    title={mimarProfit.expenseTable.deleteExpenseModal.title}
    contentClass="mb-5 pb-2 text-primary"
    content={
      <span>
        {mimarProfit.expenseTable.deleteExpenseModal.deleteConfirmationMsg}
      </span>
    }
    isContentText={false}
    confirmBtnTxt={shared.delete}
    maxWidth="xs"
    cancelBtnTxt={shared.cancel}
    handleConfirm={handleDeleteExpense}
    handleCancel={handleCloseDeleteConfirmModal}
    modalClass="delete-categories-modal"
    actionsClass="container px-4"
    confirmBtnClass="btn-secondary fsize-14 text-white py-2"
    cancelBtnClass="fsize-14 py-2"
  />
  )
}
export default DeleteExpenseModal;